import _ from 'lodash'
import Generic from './generic'

class City extends Generic {
}

export default City
